<!--
    描述：电子保函 -> 标段状态更新 -> 详情
    时间：2023-02-07
    Created by zcc
-->
<template>
  <div class="member-detail-page">
    <!-- 申请更新信息 -->
    <div class="item">
      <el-divider content-position="left">申请更新信息：</el-divider>
      <div class="main-content">
        <el-row>
          <el-col :span="6"> 业务流水号：{{ objectForm.id }} </el-col>
          <el-col :span="6"> 标段名称：{{ objectForm.bidName }} </el-col>
          <el-col :span="6"> 标段编号：{{ objectForm.bidNo }} </el-col>
          <el-col :span="6">
            项目标段唯一标识：{{ objectForm.projectBidUniqueNo }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 开标时间：{{ objectForm.bidOpeningDate }} </el-col>
          <el-col :span="6">
            瀚华标段状态：
            <span v-if="objectForm.reason == '1'">撤标</span>
            <span v-else-if="objectForm.reason == '2'">流标</span>
            <span v-else-if="objectForm.reason == '3'">延标</span>
            <span v-else-if="objectForm.reason == '4'">中标</span>
            <span v-else>其它</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            中标企业名称：{{ objectForm.winBidEnterprise }}
          </el-col>
          <el-col :span="6">
            中标企业社会信用代码：{{ objectForm.winBidCreditCode }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            保函审核编号集合：
            {{ objectForm.list.join(",") }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"> 状态变更原因说明：{{ objectForm.memo }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 申请人：{{ objectForm.applyUserName }} </el-col>
          <el-col :span="6"> 申请时间：{{ objectForm.createDate }} </el-col>
          <el-col :span="6"> 业务来源：{{ objectForm.sysSourceName }} </el-col>
        </el-row>
      </div>
    </div>
    <!-- 更新状态 -->
    <div class="item">
      <el-divider content-position="left">更新状态：</el-divider>
      <div class="main-content">
        <el-row>
          <el-col :span="6">
            处理结果：
            <span class="showStatus">
              <span :class="objectForm.updateFlag == 1 ? 'success' : 'fail'">
                {{ objectForm.updateFlag == 1 ? "成功" : "失败" }}
              </span>
            </span>
          </el-col>
          <el-col :span="6"> 更新时间：{{ objectForm.updateTime }} </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "api/modules/bh/bh-lot-status-update";
export default {
  name: "detail",
  data() {
    return {
      objectForm: {
        id: "", //业务流水号
        bidName: "", //标段名称
        bidNo: "", //标段编号
        projectBidUniqueNo: "", //项目标段唯一标识
        bidOpeningDate: "", //开标时间
        reason: "", //瀚华标段状态
        winBidEnterprise: "", //中标企业名称
        winBidCreditCode: "", //中标企业社会信用代码
        list: [], //保函审核编号集合
        memo: "", //状态变更原因说明
        applyUserName: "", //申请人
        createDate: "", //申请时间
        sysSourceName: "", //业务来源
        updateFlag: "", //处理结果
        updateTime: "", //更新时间
      },
    };
  },
  mounted() {},
  computed: {
    designUserId() {
      return this.$route.query.id;
    },
  },
  created() {
    this.getSelectSection();
  },
  methods: {
    getSelectSection() {
      let param = {
        id: this.designUserId,
      };
      API.getSelectSection(param).then((res) => {
        if (res.operationCode == 1) {
          Object.keys(this.objectForm).forEach(
            (key) => (this.objectForm[key] = res.data[key])
          );
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.member-detail-page {
  .item {
    .main-content {
      font-family: "Arial Normal", "Arial";
      font-weight: 400;
      font-style: normal;
      font-size: 13px;
      color: #333333;
      line-height: normal;
      padding: 0 40px;

      .el-row {
        padding: 10px 0px;
      }

      .showStatus {
        .success {
          color: #008000;
        }

        .fail {
          color: #ff0000;
        }
      }
    }
  }
}
</style>
